var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10384_64523)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7669 7.24634L19.8096 17.2414C19.9073 17.3663 19.9601 17.5187 19.9603 17.6762C19.961 18.0562 19.6591 18.3667 19.2816 18.3799L19.2691 18.3824L19.2491 18.3799L0.811614 18.4124C0.549115 18.4129 0.31136 18.2683 0.19095 18.036C0.0680401 17.8037 0.0850509 17.5262 0.234672 17.311L4.83297 10.6703C4.95267 10.5001 5.13998 10.3898 5.34745 10.3719C5.55241 10.3541 5.75254 10.4237 5.90029 10.566L7.85568 12.205L11.3644 7.20131L11.3625 6.12381L6.93997 6.13161C6.55247 6.13229 6.23692 5.81785 6.23624 5.43035L6.23081 2.35536C6.23013 1.96786 6.54457 1.6523 6.93207 1.65162L12.0571 1.64258C12.4421 1.6419 12.7576 1.95635 12.7583 2.34385L12.7669 7.24634Z",
    fill: "#171717"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10384_64523"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.00390625 0.0388184) rotate(-0.101015)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatmentIcon);
export default __webpack_public_path__ + "static/media/statmentIcon.9b38a053cc80024b99d1ede95e63fa01.svg";
export { ForwardRef as ReactComponent };